import { organizationRoleSchema } from '@shared/schemas/organization';
import type { OrganizationRole } from '@shared/schemas/organization';
import { authClient, hasStaticOrganizationPermission } from '@/lib/auth-client';

export function resolveOrganizationAccess(role: OrganizationRole | null) {
  return {
    canManageDatasource: role !== null
      && hasStaticOrganizationPermission(role, 'datasource', 'manage'),
    canManageMembers: role !== null
      && hasStaticOrganizationPermission(role, 'companyMember', 'read'),
    canReadCompanyBranding: role !== null
      && hasStaticOrganizationPermission(role, 'companyBranding', 'read'),
    canReadCompanyUsage: role !== null
      && hasStaticOrganizationPermission(role, 'companyUsage', 'read'),
    canReadAssistantSettings: role !== null
      && hasStaticOrganizationPermission(role, 'assistantSettings', 'read'),
    canUpdateAssistantSettings: role !== null
      && hasStaticOrganizationPermission(role, 'assistantSettings', 'update'),
    canUpdateCompanyBranding: role !== null
      && hasStaticOrganizationPermission(role, 'companyBranding', 'update'),
  };
}

export function useOrganizationAccess() {
  const memberRoleState = authClient.useActiveMemberRole();
  const parsedRole = organizationRoleSchema.safeParse(memberRoleState.data?.role);
  const role = parsedRole.success ? parsedRole.data : null;

  return {
    ...resolveOrganizationAccess(role),
    isPending: memberRoleState.isPending,
    role,
  };
}
